import React, { Component } from 'react';
import {descCompetences} from '../../models/constantes'
import { StyleSheet, css } from 'aphrodite';
import Reveal from 'react-reveal/Reveal';
import {styles} from '../common/animation';

class About extends Component {

    render() {    
        let name = "name2.png";
        return (
            <div className="screen">
                <Reveal effect={css(styles.fadeIn)} duration={1500}>
                    <h2 className="about_intro"> </h2>
                    <div className="about_description">Je me présente Klaudia Brysiewicz, <span className="about_intro-bold">développeuse Front-end</span>. Je suis désireuse à ce jour d’enrichir mon parcours professionnel  autour des technologies JavaScript (React, React Native, Angular, …), et donc d'intégrer une entreprise où j'aurai l'opportunité de confronter ma créativité à celle d'une équipe.<br/><br/>
                        <p>&emsp;Mon inventivité et ma curiosité seront des atouts indéniables pour réaliser avec succès vos futurs projets car je suis toujours au fait des dernières tendances techniques.<br/><br/></p>
                        <p>&emsp;Mes compétences me permettent de développer des sites web sans/avec des librairies (comme React)  et framework (AngularJs), et de développer également  des applications mobiles avec le framework React Natif.<br/><br/></p>
                        
                        <p>Type de contrats recherchés : <span className="about_intro-bold">FREELANCE</span> <br/>                 
                        Zone de mobilité : <span className="about_intro-bold">Ile-de-France</span>.</p>
                    </div>
                    <div className="portfolio_project-stack">
                        {descCompetences.map(el => <p className="portfolio_project-stack-element" key={el.name}>{el.name}</p>)}
                    </div>
                    <img className="about_name" src={name}  alt={"name"} />
                </Reveal>
            </div>
        );
    }
}

export default  About;


// WEBPACK FOOTER //
// ./src/components/containers/About.js